import { isObject } from '@slardar/sdk-core';
import uuid from './uuid';
export var generateSessionId = function () { return uuid(); };
export var getBatchReportURL = function (domain, path) {
    var PROTOCOL = 'https:';
    return PROTOCOL + '//' + ("" + domain) + ("" + path);
};
export var serialize = function (val) {
    var res = '';
    try {
        res = JSON.stringify(val);
        return res;
    }
    catch (_a) {
        return String(val);
    }
};
export var pick = function (obj, keys) {
    var newObj = {};
    keys.forEach(function (key) {
        newObj[key] = obj[key];
    });
    return newObj;
};
// https://stackoverflow.com/a/12205668
export var strSize = function (str) {
    return encodeURI(str).split(/%(?:u[0-9A-F]{2})?[0-9A-F]{2}|./).length - 1;
};
export var getDataLength = function (d) {
    return d
        ? d instanceof ArrayBuffer
            ? d.byteLength
            : isObject(d)
                ? strSize(serialize(d))
                : d.length
                    ? d.length
                    : 0
        : 0;
};
export var getContentLength = function (res) {
    var _a, _b, _c;
    var contentLengthKey = (_b = Object.keys((_a = res.header) !== null && _a !== void 0 ? _a : {}).find(function (k) { return k.toLowerCase() === 'content-legth'; })) !== null && _b !== void 0 ? _b : '';
    if ((_c = res.header) === null || _c === void 0 ? void 0 : _c[contentLengthKey]) {
        return parseInt(res.header[contentLengthKey]);
    }
    return getDataLength(res.data);
};
export var isHitBySampleRate = function (sampleRate) {
    if (Math.random() < Number(sampleRate)) {
        return true;
    }
    return false;
};
//# sourceMappingURL=index.js.map